import React from 'react'
// import SwanLogo from "../../assets/SwanLogo.svg"
import styles from "./HOC.module.scss";
import SwanLogo from "../SwanLogo";


const HOC = ({children}) => {
  return (
    <div className={styles.swanCtaMain}>
    <span className={styles.swanCtaMain__logo}><SwanLogo/></span>
     {children?.text ?? children}
  </div>
  )
}

export default HOC